import React, {useEffect} from "react";
import {observer} from "mobx-react";
import {
    Box,
    Typography,
    CircularProgress,
    Select,
    MenuItem,
    Accordion,
    AccordionSummary,
    AccordionDetails
} from "@material-ui/core";
import moment from "moment";
import {useStores} from "../../hooks/use-stores";
import {makeStyles} from "@material-ui/core/styles";
import {useTranslation} from "react-i18next";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import InfoIcon from "@material-ui/icons/InfoOutlined";
import MembersDataTable from "./components/MembersDataTable";
import CustomersDataTable from "./components/CustomersDataTable";
import {starFishColor} from "../../components/styles";
import SummaryRows from "./components/SummaryRows";
import {reaction} from "mobx";
import CustomersGiftCardsDataTable from "./components/CustomersGiftCardsDataTable";
import {capitalize} from "../../utils/helpers";
import Periods from "./components/Periods";

const useStyles = makeStyles((theme) => ({
       accordionSummary: {
        ...starFishColor(theme, "backgroundColor"),
        "&.Mui-expanded": {
            margin: 0,
            minHeight: 50
        },
        "& .MuiAccordionSummary-content": {
            margin: "11px 0"
        },
        "& .MuiAccordionSummary-content.Mui-expanded": {
            margin: "11px 0"
        }
    },

}));

function MyVolumePage() {
    const classes = useStyles();
    const {t} = useTranslation("myvolume");
    const {authStore, commonStore, myVolumeStore, periodsStore} = useStores();
    const {periodsLoading} = periodsStore;

    const {currentUser } = authStore;
    const {PVPeriodID, volumeData, volumeDataLoading
        , currentPeriodMemberSubtotal
        , currentPeriodCustomerSubtotal
        , currentPeriodMemberShippingTax
        , currentPeriodCustomerShippingTax
        ,currentPeriodMemberTotal
        ,currentPeriodCustomerTotal
        ,currentPeriodMemberPV
        ,currentPeriodCustomerPV
        ,currentPeriodMemberGiftCards
        ,currentPeriodCustomerGiftCards,
        currentIsMemberList,
        currentIsCustomerOrDirectCustomerList,
        SAPercent,
        currentPendingCustomerList,
        currentPendingCustomerSubtotal,
        currentPendingCustomerShippingTax,
        currentPendingCustomerTotal,
        currentPendingCustomerPV,
        giftCardsCustomers
    } = myVolumeStore;

    useEffect(() => {

        return reaction(
            () => myVolumeStore.PVPeriodID,
            PVPeriodID => {
                if (PVPeriodID) {
                    void myVolumeStore.loadVolumeData();
                }
            }
        );
    }, []);

    useEffect(() => {
        if (currentUser) {
            (async () => {
                await periodsStore.loadPeriods(currentUser.userID);
                await myVolumeStore.loadVolumeData();
            })();
        }
    }, [currentUser])


    const handleChangePeriod = (e) => {
        myVolumeStore.setPVPeriodID(e.target.value)
    }

    const showPendingInfoPopup = (e)=>{
        e.stopPropagation();
        e.preventDefault();

        commonStore.showConfirm( <p className={classes.popupText}>{t("pending_description")} </p>
            , "OK"
            , t("pending_description-title")
            , null
            , null
            , undefined
            , { hideHeader:false })
    }

    return <>
        {periodsLoading
            ? <></>
            : <>
                <Box display={"flex"} alignItems={"center"} style={{gap:16}}>
                    <Typography variant={"subtitle1"}>{t("my_volume")}</Typography>
                    <Periods periods={periodsStore.periods} PVPeriodID={PVPeriodID} handleChangePeriod={handleChangePeriod}/>
                </Box>
            </>}

        { (volumeDataLoading || periodsLoading )
            &&
            <Box alignItems="center" justifyContent="center" display="flex" minHeight={120}> <CircularProgress/> </Box>}

        { volumeDataLoading != null && !volumeDataLoading && volumeData
            ? <><Box display={"flex"} justifyContent={"flex-end"}>
                <SummaryRows t={t} showHeader={false} pv={currentPeriodMemberPV + currentPeriodCustomerPV}
                                subTotal={currentPeriodMemberSubtotal + currentPeriodCustomerSubtotal}
                                shippingTax={currentPeriodMemberShippingTax + currentPeriodCustomerShippingTax}
                                total={currentPeriodMemberTotal + currentPeriodCustomerTotal}
                />
            </Box>
<br/>
<br/>

                <Accordion defaultExpanded>
                    <AccordionSummary
                        color="primary" className={classes.accordionSummary}
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls="panel1a-content"
                        id="panel1a-header"
                    >
                        <Typography className={classes.heading}>{t("members")}</Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                        <MembersDataTable data={currentIsMemberList}
                                            subTotal={currentPeriodMemberSubtotal}
                                            shippingTax={currentPeriodMemberShippingTax}
                                            total={currentPeriodMemberTotal}
                                            pv={currentPeriodMemberPV}
                        />
                    </AccordionDetails>
                </Accordion>
                <Accordion>
                    <AccordionSummary
                        color="primary" className={classes.accordionSummary}
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls="panel1a-content"
                        id="panel1a-header"
                    >
                        <Typography className={classes.heading}>{t("customers")}</Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                        <CustomersDataTable data={currentIsCustomerOrDirectCustomerList}
                                            subTotal={currentPeriodCustomerSubtotal}
                                            shippingTax={currentPeriodCustomerShippingTax}
                                            total={currentPeriodCustomerTotal}
                                            pv={currentPeriodCustomerPV}
                                            giftCards={currentPeriodCustomerGiftCards}
                                            SAPercent={SAPercent}/>

                    </AccordionDetails>
                   

                </Accordion>
                <Accordion>
                    <AccordionSummary
                        color="primary" className={classes.accordionSummary}
                        expandIcon={<ExpandMoreIcon />}
                    >
                        <Typography className={classes.heading}>{t("pending")}
                        </Typography>
                        <InfoIcon onClick={showPendingInfoPopup} style={{cursor: "pointer", marginLeft:10 }}/>
                    </AccordionSummary>
                    <AccordionDetails>
                        <CustomersDataTable data={currentPendingCustomerList}
                                            subTotal={currentPendingCustomerSubtotal}
                                            shippingTax={currentPendingCustomerShippingTax}
                                            total={currentPendingCustomerTotal}
                                            pv={currentPendingCustomerPV}
                                            SAPercent={SAPercent}/>
                    </AccordionDetails>
                </Accordion>

                <Accordion>
                    <AccordionSummary
                        color="primary" className={classes.accordionSummary}
                        expandIcon={<ExpandMoreIcon />}
                    >
                        <Typography className={classes.heading}>{t("customer_gift_cards")}
                        </Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                        <CustomersGiftCardsDataTable data={giftCardsCustomers}/>
                    </AccordionDetails>
                </Accordion>
            </>
            : null
        }


    </>

}


export default observer(MyVolumePage)